var React = require('react');

function DtmFilled (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"32","cy":"32","r":"32","fill":"#D12F1E","key":0}),React.createElement("path",{"d":"M42.7544 35.4669L31.5862 24.8889L20.4443 35.5275L23.9596 39.1111L31.6038 31.8053L39.2567 39.0592L42.7544 35.4669Z","fill":"white","fillOpacity":"0.96","key":1})]);
}

DtmFilled.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64","fill":"none"};

module.exports = DtmFilled;

DtmFilled.default = DtmFilled;
